<div>
    <input type="text" (keyup)="pesquisaItens($event, accordion)" class="search-drop-cat-multi" placeholder="{{'PESQUISAR' | translate}}">
    <div ngbAccordion #accordion="ngbAccordion" [ngClass]="{'acc-categorias-loading': pesquisando}">
        <ng-template #recursiveList let-categories>
            <div ngbAccordionItem *ngFor="let category of categories | filter: searchCategories" [collapsed]="verifyExpandSecondaries(category)">
                <h2 ngbAccordionHeader>
                    <div *ngIf="category.sub.length > 0; else noSubCategory" class="d-flex">
                        <button ngbAccordionButton></button>
                        <span class="category-name" (click)="setCategoryAsValue(category)" [ngClass]="{'category-selected': category.selected, 'no-drop': selectOnlyLastSub && !category.last_layer}" [title]="category.nome">
                            {{category.nome}}
                            {{!category.is_ativo ? ' (' + ('INATIVO' | translate) + ')' : ''}}
                            {{category.is_excluido ? ' (' + ('EXCLUIDO' | translate) + ')' : ''}}
                        </span>
                    </div>
                    <ng-template #noSubCategory>
                        <span class="category-btn-not-child" (click)="setCategoryAsValue(category)" [ngClass]="{'category-selected': category.selected, 'last-category-layer': selectOnlyLastSub && category.last_layer}">
                            {{category.nome}}
                            {{!category.is_ativo ? ' (' + ('INATIVO' | translate) + ')' : ''}}
                            {{category.is_excluido ? ' (' + ('EXCLUIDO' | translate) + ')' : ''}}
                        </span>
                    </ng-template>
                </h2>
                <div ngbAccordionCollapse>
                    <div *ngIf="category.sub.length > 0" ngbAccordionBody>
                        <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: category.sub }"></ng-container>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: categories }"></ng-container>
    </div>
    <div *ngIf="pesquisando" class="pesquisando-categorias">
        <div class="w-100 d-flex justify-content-center">
            <div class="loader"></div>
        </div>
        <span style="margin-top: -80px; font-size: inherit; padding-left: 10px; text-align: center;">{{'PROCURANDO_ITENS' | translate}}</span>
    </div>
</div>